/* eslint-disable no-console */
import {InputNumber, InputNumberProps} from 'antd';
import React from 'react';

import {formatIndian} from '../utils/formatIndian';
import RegEx from '../utils/FormUtils/RegEx';

const NumberInput: React.FC<
  InputNumberProps & {
    isFormatted?: boolean;
    isMonYear?: {isPercent?: boolean; value?: boolean};
    inputWidth?: string;
    roundTo?: number;
  }
> = ({
  isFormatted = true,
  isMonYear = {isPercent: false, value: false},
  inputWidth = '',
  roundTo,
  ...props
}) => {
  return (
    <InputNumber
      {...props}
      controls={false}
      keyboard={false}
      min={isMonYear.isPercent ? 0 : undefined}
      max={isMonYear.isPercent ? 100 : undefined}
      // onKeyDown={(event) => {
      //   if (
      //     event.code === 'ArrowDown' ||
      //     event.code === 'ArrowUp' ||
      //     event.code === 'Enter' ||
      //     (event.code !== 'Backspace' &&
      //       event.code !== 'ArrowLeft' &&
      //       event.code !== 'ArrowRight' &&
      //       event.code !== 'Period')
      //   ) {
      //     event.preventDefault();
      //   }
      // }}
      onFocus={(e) => {
        e.target.addEventListener(
          'wheel',
          function (e) {
            e.preventDefault();
          },
          {passive: false}
        );
      }}
      formatter={(value) => {
        if (isFormatted) {
          return formatIndian(value as number);
        } else {
          return `${value}`;
        }
      }}
      parser={(value) => {
        let returnValue = '';
        if (value) {
          returnValue = value.replace(RegEx.parser, '');
          if (isMonYear.value) {
            if (isMonYear.isPercent) {
              const parsedValue =
                Math.round(Math.abs(Number(returnValue) * 100)) / 100;

              return parsedValue;
            } else {
              const parsedValue = Math.round(Math.abs(Number(returnValue)));

              return parsedValue;
            }
          } else {
            if (roundTo !== undefined && returnValue !== '') {
              const numValue = Number(returnValue);
              if (!isNaN(numValue)) {
                return Number(numValue.toFixed(roundTo));
              }
            }

            return returnValue;
          }
        } else {
          return returnValue;
        }
      }}
      style={{width: inputWidth !== '' ? inputWidth : '100%'}}
    />
  );
};

export default NumberInput;
